/*
	Сумма поля затрат USD по списку строк (типично `cost_usd`).
	Отсутствующие значения и NaN дают вклад 0.
	Каждая строка округляется до центов (как в UI), затем суммируется.
*/
function coalesceUsd(value: unknown): number {
	if (typeof value === "number") {
		return Number.isFinite(value) ? value : 0;
	}
	if (typeof value === "string" && value.trim() !== "") {
		const n = Number(value);
		return Number.isFinite(n) ? n : 0;
	}
	return 0;
}

function roundUsdCents(value: number): number {
	return Math.round(value * 100) / 100;
}

export function sumCostColumnUsd<T extends { readonly cost_usd?: unknown }>(
	items: readonly T[] | null | undefined,
): number {
	if (!items?.length) return 0;
	let sumCents = 0;
	for (const row of items) {
		sumCents += Math.round(coalesceUsd(row.cost_usd) * 100);
	}
	return roundUsdCents(sumCents / 100);
}
